export { default } from './PatientAttachments';
